import * as _ from 'lodash-es';
import { SpanProcessor } from '@opentelemetry/sdk-trace-web';
import { UAParser } from 'ua-parser-js';
import { ATTR_USER_AGENT_ORIGINAL } from '@opentelemetry/semantic-conventions';

// Custom browser attributes (no semantic conventions available)
export const CUSTOM_ATTRIBUTES = {
  USER_AGENT_VERSION: 'user_agent.version',
  USER_AGENT_NAME: 'user_agent.name',
  APP_USER_PROFILE_ID: 'app.user_profile.id',
  APP_PRACTICE_ID: 'app.practice.id',
  APP_CLIENT_ID: 'app.client.id',
  APP_ENTITY_ID: 'app.entity.id',
  APP_SUPPORT_ACCESS_REQUEST_ID: 'app.support_access_request.id'
};

const getBrowserInfo = () => {
  // You can add your custom browser tracking logic here as well.
  // This example uses the ua-parser-js package.
  const parser = new UAParser();
  const result = parser.getResult();
  return {
    userAgentOriginal: result.ua || '',
    userAgentVersion: result.browser.version || '',
    userAgentName: result.browser.name || ''
  };
};

const CustomSpanProcessor: SpanProcessor = {
  onStart: (span) => {
    const browserInfo = getBrowserInfo();

    if (navigator.userAgent) {
      span.setAttribute(ATTR_USER_AGENT_ORIGINAL, navigator.userAgent);
    }

    // Browser information (custom attributes - no semantic conventions available)
    span.setAttribute(CUSTOM_ATTRIBUTES.USER_AGENT_VERSION, browserInfo.userAgentVersion);
    span.setAttribute(CUSTOM_ATTRIBUTES.USER_AGENT_NAME, browserInfo.userAgentName);

    // User profile from OIDC storage
    const oidcKey = _.find(_.keys(sessionStorage), (k: string) => _.startsWith(k, 'oidc.user:'));
    if (oidcKey) {
      try {
        const oidcUser = JSON.parse(sessionStorage.getItem(oidcKey) || '');
        const sub = _.get(oidcUser, 'profile.sub');
        if (sub) {
          span.setAttribute(CUSTOM_ATTRIBUTES.APP_USER_PROFILE_ID, sub);
        }
      } catch (_e) {}
    }

    // App context from session storage (set via angular-local-storage which JSON-stringifies values)
    const parseStorageValue = (key: string): string | null => {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      try { return JSON.parse(raw); } catch { return raw; }
    };
    const practiceId = parseStorageValue('ls.header_PracticeId');
    const clientId = parseStorageValue('ls.header_ClientId');
    const entityId = parseStorageValue('ls.header_EntityId');
    const supportAccessRequestId = parseStorageValue('ls.header_SupportAccessRequestId');

    if (practiceId) span.setAttribute(CUSTOM_ATTRIBUTES.APP_PRACTICE_ID, practiceId);
    if (clientId) span.setAttribute(CUSTOM_ATTRIBUTES.APP_CLIENT_ID, clientId);
    if (entityId) span.setAttribute(CUSTOM_ATTRIBUTES.APP_ENTITY_ID, entityId);
    if (supportAccessRequestId)
      span.setAttribute(CUSTOM_ATTRIBUTES.APP_SUPPORT_ACCESS_REQUEST_ID, supportAccessRequestId);
  },
  onEnd: () => Promise.resolve(),
  forceFlush: () => Promise.resolve(),
  shutdown: () => Promise.resolve()
};

export default CustomSpanProcessor;
